export const TARGET_BACKEND = 'dev';
export const LOCAL_SERVER_REPLACE_LOOKUP: Record<string, string> = {
    'localhost:5137': 'https://paul.gowwise.com',
    'www-localhost.gowwise.com': 'https://paul.gowwise.com',

    preprod: 'https://preprod.gowwise.com',
    dev: 'https://dev.gowwise.com',
    staging: 'https://staging.gowwise.com',
    francis: 'https://francis.gowwise.com',
    jonathan: 'https://jonathan.gowwise.com',
    kierk: 'https://kierk.gowwise.com',
    olivier: 'https://olivier.gowwise.com',
    paul: 'https://paul.gowwise.com',
};

export function loginDomain(domain: string) {
    const goWwiseSubDomain = domain.replace('.gowwise.com', '');

    if (['preprod'].includes(goWwiseSubDomain)) {
        return 'auth-preprod.gowwise.com';
    }

    if (['localhost', 'www-localhost'].includes(goWwiseSubDomain)) {
        return `${TARGET_BACKEND}-web.auth.us-west-1.amazoncognito.com`;
    }

    if (domain.indexOf('gowwise.com') !== -1) {
        return `${goWwiseSubDomain}-web.auth.us-west-1.amazoncognito.com`;
    }

    if (domain.indexOf('audiokinetic.c') !== -1) {
        return 'auth.audiokinetic.com';
    }

    return 'UNCONFIGURED_DOMAIN';
}
